import Isotope from "isotope-layout";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

export default () => {
  let gallery = document.querySelector(".gallery");
  let onClickLoad = document.querySelector(".onClickLoad");

  if (!gallery) {
    return;
  }

  galleryInit(gallery);

  function galleryInit(gallery) {
    let shortsBlock = gallery.querySelectorAll(".img-short");
    let videoBlock = gallery.querySelectorAll(".gallery__video");
    let video_Btn = document.querySelector(".video_Btn");
    let newIndex = 0;

    shortsBlock.forEach((el, index, array) => {
      if (newIndex % 2 === 0) {
        let line = document.createElement("div");
        line.setAttribute("class", "gallery__line");
        array[index].parentNode.insertBefore(line, array[index]);
        line.appendChild(array[index]);

        if (line.nextElementSibling) {
          let nextDiv = line.nextElementSibling.classList.contains("img-long");
          if (nextDiv) {
            newIndex++;
          }
        }
      }
      newIndex++;
    });

    video_Btn.style.display = "none";

    videoBlock.forEach((el) => {
      console.log(el);

      if (!el) {
        video_Btn.style.display = "none";
      } else {
        video_Btn.style.display = "inline-block";
      }
    });
  }

  // onClickLoad.addEventListener('click', function(){
  //     galleryInit(gallery);
  // });

  gsap.registerPlugin(ScrollTrigger);
  const OFFSET = "top bottom-=200px";
  let elem = document.querySelector(".gallery__inner");
  let iso = new Isotope(elem, {
    itemSelector: ".gallery__image-container",
    layoutMode: "fitRows",
    hiddenStyle: {
      opacity: 0,
    },
    visibleStyle: {
      opacity: 1,
    },
  });

  let filterBtn = [
    ...document.querySelectorAll(
      ".activities-hero__filter .activities-hero__filter-btn"
    ),
  ];

  const removeActiveClass = () => {
    filterBtn.forEach((btn) => {
      btn.classList.remove("activities-hero__filter-btn--active");
    });
  };

  for (let i = 0; i < filterBtn.length; i++) {
    filterBtn[i].addEventListener("click", (e) => {
      removeActiveClass();

      gsap.to(".gallery__inner", {
        opacity: 0,
        duration: 0.3,
        delay: 0,
      });

      gsap.to(".gallery__inner", {
        opacity: 1,
        duration: 2,
        delay: 0.3,
      });

      filterBtn[i].classList.add("activities-hero__filter-btn--active");
      let filterData = e.target.getAttribute("data-filter");

      iso.arrange({
        filter: filterData,
      });
    });
  }

  function newTimeLine() {
    const fadeYElements = document.querySelectorAll("[animation-fadeY]");

    fadeYElements.forEach((el) => {
      const timeLine = gsap.timeline({
        scrollTrigger: {
          trigger: el,
          start: OFFSET,
        },
      });
      timeLine.to(el, {
        y: 0,
        ease: "Power1.easeOut",
        duration: 2,
        delay: 0,
        onStart: () => {
          gsap.to(el, {
            opacity: 1,
            ease: "Power1.easeIn",
            duration: 1,
            delay: 0,
          });
        },
      });
    });
  }
};
